import PropTypes from 'prop-types';

function IconCheckmark({ fill }) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 16C12.9183 16 16.5 12.4183 16.5 8C16.5 3.58172 12.9183 0 8.5 0C4.08172 0 0.5 3.58172 0.5 8C0.5 12.4183 4.08172 16 8.5 16ZM3.83333 8.33333L4.83333 7.33333L7.16667 9.66667L12.1667 4.66667L13.1667 5.66667L7.16667 11.6667L3.83333 8.33333Z"
        fill={fill}
      />
    </svg>
  );
}

IconCheckmark.propTypes = {
  fill: PropTypes.string,
};

IconCheckmark.defaultProps = {
  fill: 'black',
};

export default IconCheckmark;
